import { get } from 'mori';
import { appState } from 'state';
import { reportsHashPathFromWindow, resolveReportsVenueId } from 'src/url-states/reports-hash';

const DATE_KEY = 'reports/transactions/date';

/**
 * Reads YYYY-MM-DD from window.location.hash when it matches the transactions report route (returns null otherwise).
 * (same shape as React Router's `/venue/:venueId/transactions/:date?` inside HashRouter).
 */
export const parseTransactionReportDateFromWindowHash = (): string | null => {
  const path = reportsHashPathFromWindow();
  const m = path.match(/^venue\/\d+\/transactions\/(\d{4}-\d{2}-\d{2})(?:\/|$)/);
  return m ? m[1] : null;
};

export function getHash(): string | null {
  const state = appState.deref();
  const date = get(state, DATE_KEY);
  const venueId = resolveReportsVenueId();
  if (venueId == null || `${venueId}` === '') {
    return null;
  }

  return `#venue/${venueId}/transactions/${date}`;
}
